<template>
    <div class="role_warp">
      <!-- 头部工具栏 -->
      <div class="role_heard_tool">
        <el-button
          type="success"
          size="mini"
          
          @click="getList"
          >刷新</el-button
        >
        <el-button
          type="primary"
          class="edit-button"
          size="mini"
          style="margin-left: 10px"
          @click="select()"
          >筛选</el-button
        >
          <!-- <el-button
        type="primary"
        class="edit-button"
        size="mini"
        style="margin-left: 10px;background:#06CC00;border:1px solid #06CC00;margin-bottom: 5px;"
        @click="checkSuccessList(2)"
        >批量通过</el-button
      >
      <el-button
        type="primary"
        class="edit-button"
        size="mini"
        style="margin-left: 10px;background:#FF0000;border:1px solid #FF0000;margin-bottom: 5px;"
        @click="checkRejectList(2)"
        >批量拒绝</el-button
      > -->
      </div>
      <div class="head_search">
        <div class="item_warp">
          <label style="margin: 0 10px;">用户UID</label>
          <el-input
            v-model="memberUid"
            placeholder="请输入用户UID"
            style="width: 120px"
            size="mini"
            clearable
          />
        </div>
      </div>
      <!-- 表单 -->
      <el-table
        ref="gridTable"
        v-loading="loading"
        :data="tableData"
        tooltip-effect="dark"
        :stripe="true"
        :border="true"
        height="calc(100vh - 240px )"
        style="width: 901px"
        size="mini"
        @selection-change="handleSelectionChange"
      >
       <el-table-column prop="memberUid" label="UID" width="100" />
       <el-table-column prop="address" label="地区" width="150">
        <template slot-scope="scope">
          <div>
            <div>{{ scope.row.cn }}</div>
            <div>({{ scope.row.currency }})</div>
          </div>
        </template>
      </el-table-column>
       <el-table-column prop="address" label="登录IP" width="160">
        <template slot-scope="scope">
          <div>
            <div>{{ scope.row.ip }}</div>
            <div>{{ scope.row.ipAddress }}</div>
          </div>
        </template>
      </el-table-column>
       <el-table-column prop="x1" label="普通查看" width="100" />
       <el-table-column prop="x2" label="购买查看" width="100">
        <template #header>
            <div class="flex">
              <span class="gbRed">购买查看</span>
              <img @click="selectOrder('购买查看','asc')" v-if="realAirdropBuyAmount == 'desc'" style="width:20px;cursor: pointer;" src="@/img/order_desc.png" alt="">
              <img @click="selectOrder('购买查看','')" v-if="realAirdropBuyAmount == 'asc'" style="width:20px;cursor: pointer" src="@/img/order_asc.png" alt="">
              <img @click="selectOrder('购买查看','desc')" v-if="realAirdropBuyAmount == ''" style="width:20px;cursor: pointer" src="@/img/order_no.png" alt="">
            </div>  
          </template> 
      </el-table-column>
       <el-table-column prop="x3" label="提交已转账" width="100" />
       <el-table-column prop="x4" label="交易成功" width="100" />
       <el-table-column prop="x5" label="交易成功金额" width="110" />
       <el-table-column prop="x6" label="手动取消" width="100" />
       <el-table-column prop="x7" label="超时取消" width="100" />
       <el-table-column prop="remainViewCount" label="剩余查看次数" width="130">
        <template #header>
            <div class="flex">
              <span class="gbRed">剩余查看次数</span>
              <img @click="selectOrder('剩余查看次数','asc')" v-if="remainViewCount == 'desc'" style="width:20px;cursor: pointer;" src="@/img/order_desc.png" alt="">
              <img @click="selectOrder('剩余查看次数','')" v-if="remainViewCount == 'asc'" style="width:20px;cursor: pointer" src="@/img/order_asc.png" alt="">
              <img @click="selectOrder('剩余查看次数','desc')" v-if="remainViewCount == ''" style="width:20px;cursor: pointer" src="@/img/order_no.png" alt="">
            </div> 
          </template>
      </el-table-column>
       <el-table-column prop="address" label="认证状态" width="130">
          <template slot-scope="scoped">
            <div style="display: flex;align-items: center;justify-content: center;color:#999" v-if="scoped.row.verifyStatus === null">
                未提交
            </div> 
            <div style="display: flex;align-items: center;justify-content: center;color:#999" v-if="scoped.row.verifyStatus === 0">
                审核中
            </div> 
            <div style="display: flex;align-items: center;justify-content: center;color: #06CC00" v-if="scoped.row.status === 1">
                审核通过
            </div>
            <div style="display: flex;align-items: center;justify-content: center;color: red;" v-if="scoped.row.status === 2">
                审核不通过
            </div>
          </template>
        </el-table-column> 
      </el-table>
      <!-- 分页 -->
      <pagination
        v-show="total > 0"
        :total="total"
        :page.sync="pageNum"
        :limit.sync="pageSize"
        @pagination="getList"
      />
      <el-dialog
      :visible.sync="edit_dialogVisible"
      width="400px"
      title="编辑"
      :center="true"
      :close-on-click-modal="false"
    >
    <el-form ref="editForm" :model="active" label-width="120px">
        <el-form-item label="修改所在地区">
         <el-select v-model="currency" style="width: 200px" placeholder="请选择" clearable>
            <el-option v-for="(item,index) in list" :key="index" :label="item.countryNameCn" :value="item.currency"></el-option>
         </el-select>
        </el-form-item>
        <el-form-item>
          <el-popconfirm title="确定修改？" @confirm="updateCurrency()">
            <el-button slot="reference" type="primary" class="edit-button"
              >确定</el-button
            >
          </el-popconfirm>
        </el-form-item>
      </el-form>
    </el-dialog>
    </div>
  </template>
  
  <script>
  import Pagination from "@/components/Pagination"; // 引入分页器
  import UploadImage from "@/components/Upload/UploadPic"; // 引入分页器
  import VueUeditorWrap from 'vue-ueditor-wrap' // ES6 Module
  
  import validEmail from "@/utils/validate"; // 引入邮箱验证方法
  import md5 from "js-md5"; // 引入Md5加密
  
  export default {
    name: "Management",
    components: { Pagination,VueUeditorWrap,UploadImage },
    data() {
      return {
        option: "", // 初始选项
        options: [], // 选择角色
        name: "", // 搜索的管理员名称
        tableData: [], // 展示的表单信息
        // 添加表单
        active: {},
        // 修改表单
        editForm: { },
        total: 0, // 总数
        pageNum: 1, // 页码值
        pageSize: 20, // 页大小
        historyList: [], // 选中项s
        yiFangDetailList: [], // 
        dialogVisible: false, // 添加弹窗
        dialog: false, // 添加弹窗
        edit_dialogVisible: false, // 编辑弹窗
        Isedit: false, // 是否是编辑弹窗
        loading: false, // 表格加
        buttongLoding: false, // 按钮加载
        sn:'',
        lang:'en',
        isEnabled:false,
        isChat:false,
        isTelegram:false,
        isWhatsApp:false,
        isMessenger:false,
        isLinkUrl:false,
        isTelegramGroup:false,
        dialogVisibleUpdate:false,
        dataTime:['',''],
        yifangId:'',
        status:'',
        ipCount:'',
        type:'',
        memberUid:'',
        list:[],
        currency:"",
        id:'',
        realAirdropBuyAmount:'',
        remainViewCount:''
        
      };
    },
    mounted() {
      this.getList();
      this.countryList()
    },
    methods: {
    selectOrder(name,type){
      this.remainViewCount=''
      this.realAirdropBuyAmount =''

      
      if(name == '剩余查看次数'){
        this.remainViewCount=type
      }
      if(name == '购买查看'){
        this.realAirdropBuyAmount=type
      }
      this.pageNum = 1;
      this.getList();

    },
      previewImg(list){
    let list1 = []
    list.forEach(item => {
      list1.push(item+'?x-oss-process=image/resize,w_450')
    })
    return list1
  },
    getChildrenSum(row) {
      this.historyList = row;
      this.edit_dialogVisible = true
    },
      handleClickItem() {
        this.$nextTick(() => {
          // 获取遮罩层dom
          const domImageMask = document.querySelector('.el-image-viewer__mask')
          if (!domImageMask) {
            return
          }
          domImageMask.addEventListener('click', () => {
            // 点击遮罩层时调用关闭按钮的 click 事件
            document.querySelector('.el-image-viewer__close').click()
          })
        })
      },
      // 筛选
      select() {
        this.pageNum = 1;
        this.getList();
      },
      // 批量审核通过
    checkSuccessList(type,row){
        if(type == 1){
      this.$api.c2c
        .approveCcMemberVerification({
            id:row.id
        })
        .then((res) => {
          this.$message.success(res);
        })
        .catch((err) => {
          this.$message.error(err || "服务器错误，请稍后重试");
        })
        .finally(() => {
          this.getList();
        });
  
        }
        if(type == 2){
            if (!this.multipleSelection || this.multipleSelection.length < 1) {
        return this.$message.info("你并没有选中任何选项");
      }
      this.$confirm("是否批量审核通过?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        var ids = [];
      this.multipleSelection.forEach((item) => {
        ids.push(item.id);
      });
      var params = {
        ids: ids.toString(),
      };
      this.$api.c2c
        .approveList(params)
        .then((res) => {
          this.$message.success(res);
        })
        .catch((err) => {
          this.$message.error(err || "服务器错误，请稍后重试");
        })
        .finally(() => {
          this.getList();
        });
          
      })
  
        }
    },
    countryList(row){
      if(row){
        this.id = row.id
        this.currency = row.currency
      }
      if(this.list.length > 0){
        this.edit_dialogVisible = true
      }else{
        if(row) this.edit_dialogVisible = true;
        this.$api.c2c
        .countryList()
        .then((res) => {
          let obj = res
					var arr = [];
					for (var key in obj) {
					  arr.push(obj[key]);
					}
					this.list = arr
        })
        .catch((err) => {
          this.$message.error(err || "服务器错误，请稍后重试");
        })
        .finally(() => {
         
        });

      }
    },
    updateCurrency(){
      this.$api.c2c
        .updateCurrency({
            id:this.id,
            currency:this.currency
        })
        .then((res) => {
          this.edit_dialogVisible = false
          this.$message.success(res);
        })
        .catch((err) => {
          this.$message.error(err || "服务器错误，请稍后重试");
        })
        .finally(() => {
          this.getList();
        });
    },
    checkRejectList(type,row){
        if(type == 1){
      this.$api.c2c
        .rejectCcMemberVerification({
            id:row.id
        })
        .then((res) => {
          this.$message.success(res);
        })
        .catch((err) => {
          this.$message.error(err || "服务器错误，请稍后重试");
        })
        .finally(() => {
          this.getList();
        });
  
        }
      if(type == 2){
        if (!this.multipleSelection || this.multipleSelection.length < 1) {
        return this.$message.info("你并没有选中任何选项");
      }
      this.$confirm("是否批量审核拒绝?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        var ids = [];
      this.multipleSelection.forEach((item) => {
        ids.push(item.id);
      });
      var params = {
        ids: ids.toString(),
      };
      this.$api.c2c
        .CcMemberVerification(params)
        .then((res) => {
          this.$message.success(res);
        })
        .catch((err) => {
          this.$message.error(err || "服务器错误，请稍后重试");
        })
        .finally(() => {
          this.getList();
        });
          
      }).catch(() => {
        
        });
      }
    },
      // 获取表单信息
      getList() {
        var params = {
          pageNumber: this.pageNum,
          pageSize: this.pageSize,
          x2: this.realAirdropBuyAmount,
          remainViewCount: this.remainViewCount,
          uid:this.memberUid
        };
        this.loading = true;
        this.$refs.gridTable.bodyWrapper.scrollTop = 0;
          this.$api.c2c
          .ccMemberBehaviorList(params)
          .then((res) => {
            this.tableData = res.records;
            this.total = res.total;
          })
          .catch((err) => {
            this.$message.error(err || "服务器错误，请稍后重试");
          })
          .finally(() => {
            this.loading = false;
          });
      },
      // 选择或者取消行，支持全选
      handleSelectionChange(val) {
        this.multipleSelection = val;
      },
      // 关闭添加弹窗
      handleClose() {
        this.$refs.active.resetFields();
      },
      // 关闭修改弹窗
      editClose(done) {
        this.editInfo = {};
        done();
      },
      // 删除选中项
      handleDel() {
        var ids = [];
        this.multipleSelection.forEach((item) => {
          ids.push(item.id);
        });
        var params = {
          ids: ids.toString(),
        };
        this.$api.c2c
          .bannerDelete(params)
          .then((res) => {
            this.$message.success(res);
          })
          .catch((err) => {
            this.$message.error(err || "服务器错误，请稍后重试");
          })
          .finally(() => {
            this.getList();
          });
      },
      happenTimeFun(num){
      let date = new Date(num);
      //时间戳为10位需*1000，时间戳为13位的话不需乘1000
      let y = date.getFullYear();
      let MM = date.getMonth() + 1;
      MM = MM < 10 ? ('0' + MM) : MM; //月补0
      let d = date.getDate();
      d = d < 10 ? ('0' + d) : d; //天补0
      let h = date.getHours();
      h = h < 10 ? ('0' + h) : h; //小时补0
      let m = date.getMinutes();
      m = m < 10 ? ('0' + m) : m; //分钟补0
      let s = date.getSeconds();
      s = s < 10 ? ('0' + s) : s; //秒补0
      return y + '-' + MM + '-' + d + ' ' + h + ':' + m + ':' + s
  },
      // 添加用户
      bannerSave() {
            this.$api.c2c
              .bannerSave(this.active)
              .then((res) => {
                this.$message.success(res);
                this.dialogVisible = false;
                this.getList();
              })
              .catch((err) => {
                this.$message.error(err || "服务器错误，请稍后重试");
              })
              .finally(() => {
                this.buttongLoding = false;
              });
      },
      // 打开删除弹窗
      openDelete() {
        if (!this.multipleSelection || this.multipleSelection.length < 1) {
          return this.$message.info("你并没有选中任何选项");
        }
        this.$confirm("是否删除?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            this.handleDel();
          })
          .catch(() => {
            
          });
      },
     
    },
  };
  </script>
  <style lang="scss" scoped>
  .role_warp {
    font-size: 14px;
    padding: 10px;
    box-sizing: border-box;
    .role_heard_tool {
      margin-bottom: 10px;
    }
    .edit_titile {
      .dialog_input {
        // width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-around;
        width: 70%;
        span {
          flex: 1;
          display: flex;
          justify-content: flex-end;
          margin-right: 20px;
        }
        .el-input {
          flex: 3;
        }
      }
    }
    .tree {
      margin-top: 25px;
      display: flex;
      justify-content: space-around;
    }
    .authority_info {
      margin-top: 25px;
    }
  }
  .el-input {
    width: 70%;
  }
  ::v-deep .el-pagination{
  white-space: wrap !important;
  }
  </style>
  